import { useCallback, useMemo } from 'react';

import { useAccountSlug } from '@/hooks/use-account-slug';
import { domainMeta } from '@/utils/domain-meta';

export function useHireUrl() {
  const accountSlug = useAccountSlug();

  const getHireApplicantTableUrl = useCallback(
    (brand: string, location?: string, funnel?: string) => {
      if (!location || !funnel) return '';

      return (
        `${domainMeta.recruiterUiOrigin}/${accountSlug}/brands/${brand}` +
        `/locations/${location}/jobs/${funnel}/v2/stages`
      );
    },
    [accountSlug],
  );

  const getHireATHiringGoalUrl = useCallback(
    (brand: string, location?: string, funnel?: string) => {
      const baseUrl = getHireApplicantTableUrl(brand, location, funnel);
      if (baseUrl === '') return '';

      const url = new URL(baseUrl);
      url.searchParams.set('openHiringGoalModal', 'true');

      return url.toString();
    },
    [getHireApplicantTableUrl],
  );

  const getHireSourcingUrl = useCallback(
    (channel: string, openingId?: string) => {
      if (!openingId) return '';

      const channelSlug = channel === 'spring' ? 'vonq' : channel;
      return `${domainMeta.recruiterUiOrigin}/${accountSlug}/sourcing/${channelSlug}/new/${openingId}`;
    },
    [accountSlug],
  );

  const hireConversionTrackingUrl = useMemo(() => {
    return `${domainMeta.monolithOrigin}/${accountSlug}/conversion_trackings`;
  }, [accountSlug]);

  return {
    getHireApplicantTableUrl,
    getHireATHiringGoalUrl,
    getHireSourcingUrl,
    hireConversionTrackingUrl,
  };
}
